import { NAME } from "./constants";

export const GET_USER_LOCKS = NAME + "_GET_USER_LOCKS";
